import { AggregatorClient, 
// getAllProviders,
getProvidersExcluding, } from '@cetusprotocol/aggregator-sdk';
import { Transaction } from '@mysten/sui/transactions';
import BN from 'bn.js';
export class CetusSwap {
    network;
    client;
    cetusRouterDataV3;
    constructor(network) {
        this.network = network;
        this.client = new AggregatorClient({});
        this.cetusRouterDataV3 = null;
    }
    async getCetusSwapQuote(from, target, amount, byAmountIn) {
        try {
            // const providers = getAllProviders();
            const providersExcept = getProvidersExcluding([
                'STEAMM_OMM_V2',
                'OBRIC',
                'METASTABLE',
                'HAEDALHMMV2',
                'HAEDALPMM',
            ]);
            const router = await this.client.findRouters({
                from,
                target,
                amount,
                byAmountIn, // `true` means fix input amount, `false` means fix output amount
                providers: providersExcept,
                splitCount: 15,
            });
            return router || undefined;
        }
        catch (error) {
            console.error('Error getting cetus swap quote', error);
            throw error;
        }
    }
    async cetusSimpleSwapTokensTxb(router, slippage, existingTx) {
        try {
            if (!router) {
                throw new Error('No routers found');
            }
            const txb = existingTx || new Transaction();
            await this.client.fastRouterSwap({
                router,
                txb,
                slippage: slippage || 0.01, // 1% slippage
            });
            return txb;
        }
        catch (error) {
            console.error('Error swapping tokens in cetus swap', error);
            throw error;
        }
    }
    async cetusSwapTokensTxb(router, slippage, inputCoin, txb) {
        try {
            if (!router) {
                throw new Error('No routers found');
            }
            // Use routerSwapWithMaxAmountIn when explicit coin control is needed
            const coinOut = await this.client.routerSwapWithMaxAmountIn({
                router,
                txb,
                inputCoin: inputCoin,
                slippage: slippage || 0.01,
                maxAmountIn: new BN(router.amountIn.toString()),
            });
            return { tx: txb, coinOut };
        }
        catch (error) {
            console.error('Error swapping tokens in cetus swap', error);
            throw error;
        }
    }
}
//# sourceMappingURL=swap.js.map